import { mainApiFetch, requestFailed } from '../../Staff/helpers/evidence/routingHelpers'

export interface ReadAloudSettings {
  enabled: boolean;
  source: string;
}

export const fetchReadAloudSettings = async (activitySessionUid?: string | null): Promise<ReadAloudSettings> => {
  const query = activitySessionUid ? `?activity_session_uid=${encodeURIComponent(activitySessionUid)}` : ''
  const response = await mainApiFetch(`read_aloud_settings${query}`)

  if (requestFailed(response.status)) { throw new Error(`Read aloud settings HTTP status: ${response.status}`) }

  const { enabled, source, } = await response.json()
  return { enabled: enabled === true, source, }
}

export interface ClipMissReport {
  reason: string;
  source_id: string;
  source_type: string;
  text_hash: string;
}

export const postClipMiss = (report: ClipMissReport) => mainApiFetch('read_aloud/clips', { body: JSON.stringify(report), method: 'POST', })
